import { Link } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { useMySubscription } from '../../api/billing';
import { ContactSales, PlansCatalog } from './PlansCatalog';

/**
 * In-app "Plans" menu (/plans) - every member can see what each plan
 * includes, not only those with billing access. Members who manage billing
 * are sent to Billing to change plan; others are told who can.
 */
export function PlansOverviewPage() {
  const { hasPermission } = useAuth();
  const canSeeBilling = hasPermission('billing.read');
  // Only readable with billing access; others just don't get the marker.
  const subscription = useMySubscription(canSeeBilling);
  const currentCode = subscription.data?.planCode ?? null;

  return (
    <div style={{ display: 'grid', gap: 'var(--space-4)' }}>
      <div>
        <h1 style={{ margin: 0, fontSize: 'var(--font-size-xl)' }}>Plans</h1>
        <p style={{ margin: 'var(--space-1) 0 0', color: 'var(--color-text-muted)' }}>
          What each plan includes.{' '}
          {canSeeBilling ? (
            <>
              Change your plan in <Link to="/billing">Billing</Link>.
            </>
          ) : (
            'Your workspace owner or an admin can change the plan.'
          )}
        </p>
      </div>
      <PlansCatalog
        highlightCode={currentCode}
        actionFor={(plan) =>
          plan.code === currentCode ? (
            <span className="ne-badge">Current plan</span>
          ) : plan.isCustomPricing ? (
            <ContactSales plan={plan} />
          ) : canSeeBilling ? (
            <Link to="/billing" className="ne-btn ne-btn--secondary">
              Change plan in Billing
            </Link>
          ) : null
        }
      />
    </div>
  );
}
